import { useState } from "react";
import StaffGuidesTable from "./staff-guides-table";
import Text from "antd/es/typography/Text";
import { BookOutlined, CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { Divider } from "antd/lib";
import CBFiles from "../shared/CBFiles/CBFiles";
import { Button, UploadFile } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string } from "yup";
import { CBInput } from "../shared";
import Message from "../shared/Message/Message";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { createGuide } from "../../services/guides.service";
import { useRole } from "../../hooks/user-roles";
import { useNavigate } from "react-router-dom";

export default function StaffGuides() {
  const { isAdmin } = useRole();
  const queryClient = useQueryClient();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm({
    mode: "onBlur",
    resolver: yupResolver(
      object({
        description: string().required(),
      }),
    ),
    defaultValues: {
      description: "",
    },
  });
  const mutationOnSuccess = () => {
    Message().success("Guide has been added!");
    reset();
    setFileList([]);
    queryClient.invalidateQueries({
      queryKey: [`guides-files`],
    });
  };
  const mutationOnError = (response: AxiosError) => {
    Message().error(response.message);
  };

  const createGuideMutation = useMutation({
    mutationFn: (info: { description: string }) => {
      return createGuide(info, fileList);
    },
    onSuccess: mutationOnSuccess,
    onError: mutationOnError,
  });
  const submitHandler = (info: { description: string }) => {
    console.log("entro", info);
    createGuideMutation.mutate(info);
  };

  return (
    <div className="p-4">
      <div className="max-w-screen-md m-auto pt-4">
        <div className="w-sm flex flex-col items-center m-auto text-center max-w-md">
          <BookOutlined className="warning" style={{ fontSize: "40px" }} />
          <Text>
            The following user guides are here to support you as a Team Member
            on how to manage your courses and communicate with students, Enjoy!
          </Text>
        </div>
        <Divider />
        {isAdmin && (
          <form
            className="p-3 text-center"
            onSubmit={handleSubmit(submitHandler)}
          >
            <div className="flex content-between">
              <CBInput
                className="flex-1"
                control={control}
                label="Description"
                name="description"
                required
                placeholder=""
              />
              <CBFiles
                {...{ fileList, setFileList }}
                name="files"
                filesLimit={1}
                className="flex-1 flex flex-col-reverse pl-4"
              />
            </div>
            <Button type="primary" htmlType="submit" icon={<UploadOutlined />}>
              Upload
            </Button>
            <Divider />
          </form>
        )}
        <StaffGuidesTable></StaffGuidesTable>
        <div className="flex space-x-2.5 > * + * justify-center mt-5">
          <Button
            className="box-border"
            type="primary"
            icon={<CloseOutlined />}
            danger
            onClick={() => {
              navigate(`/SEABC/dashboard`);
            }}
          >
            Exit
          </Button>
        </div>
      </div>
    </div>
  );
}
